module.exports = __webpack_public_path__ + "media/images/emblems/Vernayaz-8cbd9b51e3aa84028963773dc4beea8e.png";